module.exports = __webpack_public_path__ + "media/nie-skompletowales.407b4d5f.mp3";